module.exports = __webpack_public_path__ + "img/para_de_minas_logo.35c54174.png";